import React from 'react';
import clsx from 'clsx';
import styles from './SelectionBar.module.scss';

interface SelectionBarItemProps {
    label: React.ReactNode;
    selected: boolean;
    onClick: () => void;
    className?: string;
    selectedBackgroundColor?: string;
}

export const SelectionBarItem: React.FunctionComponent<SelectionBarItemProps> = ({
    label,
    selected,
    onClick,
    className,
    selectedBackgroundColor
}) => {
    const containerClasses = clsx(
        styles.item,
        {
            [styles.itemSelected]: selected
        },
        className
    );

    const customStyle = selected && selectedBackgroundColor ? { backgroundColor: selectedBackgroundColor } : {};

    return (
        <div
            className={containerClasses}
            onClick={onClick}
            style={customStyle}
        >
            {label}
        </div>
    );
};

export default SelectionBarItem;
